const workerListGridConfig = {
    columns: [
        {
            id: 1,
            width: 325,
            selector: 'name',
            name: 'Име',
            sequenceNumber: 1,
            type: 'string'
        },
        {
            id: 2,
            width: 150,
            selector: 'code',
            name: 'Код',
            sequenceNumber: 2,
            type: 'string'
        }
    ],
    props: {
        headerRowHeight: 50,
        rowHeight: 52,
        tableHeight: 600,
        filterable: true,
        selectableColumn: {
            show: true,
            icon: 'far fa-edit',
            width: 90
        }
    }
};

export default workerListGridConfig;